import axios from 'axios';
import {
  DafGrantType,
  DafAuthResponse,
} from '@nab/x-runtime';
import constants from './constants';

export const checkHashTokenValidity = async (dafEndpoint, subjectToken, clientId): Promise<boolean> => {
  try {
    const response = await axios.post<DafAuthResponse>(dafEndpoint, {
      client_id: clientId,
      grant_type: DafGrantType.tokenExchange,
      requested_token_type: constants.STANDALONE_EXCHANGE_TOKEN_TYPE,
      subject_token: subjectToken,
      subject_token_type: constants.STANDALONE_EXCHANGE_TOKEN_TYPE,
      scope: constants.STANDALONE_EXCHANGE_SCOPE
    });
    return response.status === 200;
  } catch (e) {
    return false;
  }
}